var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable lines-around-comment */
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
// @ts-ignore
import participantsPaneTheme from '../../../base/components/themes/participantsPaneTheme.json';
import { openDialog } from '../../../base/dialog/actions';
import { IconDotsHorizontal, IconClose } from '../../../base/icons/svg';
import { getHistoryParticipant, getMaxConCurrentParticipant, getParticipantById, isLocalParticipantModerator, isScreenShareParticipant } from '../../../base/participants/functions';
import Button from '../../../base/ui/components/web/Button';
import ClickableIcon from '../../../base/ui/components/web/ClickableIcon';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
import { findAncestorByClass } from '../../../base/ui/functions.web';
import { isAddBreakoutRoomButtonVisible } from '../../../breakout-rooms/functions';
// @ts-ignore
import { MuteEveryoneDialog } from '../../../video-menu/components/';
import { close } from '../../actions.web';
import { getParticipantsPaneOpen, getSortedParticipantIds, isMoreActionsVisible, isMuteAllVisible } from '../../functions';
// @ts-ignore
import { RoomList } from '../breakout-rooms/components/web/RoomList';
import { FooterContextMenu } from './FooterContextMenu';
import LobbyParticipants from './LobbyParticipants';
import MeetingParticipants from './MeetingParticipants';
import { connect } from "../../../base/redux/functions";
// @ts-ignore
const useStyles = makeStyles()(theme => {
    return {
        container: {
            boxSizing: 'border-box',
            flex: 1,
            overflowY: 'auto',
            position: 'relative',
            padding: `0 ${participantsPaneTheme.panePadding}px`,
            [`& > * + *:not(.${participantsPaneTheme.ignoredChildClassName})`]: {
                marginTop: theme.spacing(3)
            },
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        closeButton: {
            alignItems: 'center',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center'
        },
        header: {
            height: '60px',
            position: 'relative',
            width: '100%',
            zIndex: 1,
            display: 'flex',
            justifyContent: 'space-between',
            padding: '16px',
            alignItems: 'center',
            boxSizing: 'border-box',
            color: '#fff',
            fontWeight: '600',
            fontSize: '16px',
            lineHeight: '32px',
            backgroundColor: 'black',
            marginBottom: '12px'
        },
        antiCollapse: {
            fontSize: 0,
            '&:first-child': {
                display: 'none'
            },
            '&:first-child + *': {
                marginTop: 0
            }
        },
        footer: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: `${theme.spacing(4)} ${participantsPaneTheme.panePadding}px`,
            '& > *:not(:last-child)': {
                marginRight: theme.spacing(3)
            }
        },
        footerMoreContainer: {
            position: 'relative'
        }
    };
});
const ParticipantsPane = React.forwardRef(({ participantsCount, historyParticipantLength, conCurrentParticipant, sortedParticipantIds = [] }, ref) => {
    var _a, _b;
    let maxConcurrentParticipants = 0;
    let maxParticipants = 0;
    const { classes } = useStyles();
    const paneOpen = useSelector(getParticipantsPaneOpen);
    const isBreakoutRoomsSupported = (_b = (_a = useSelector((state) => state['features/base/conference'])
        .conference) === null || _a === void 0 ? void 0 : _a.getBreakoutRooms()) === null || _b === void 0 ? void 0 : _b.isSupported();
    const showAddRoomButton = useSelector(isAddBreakoutRoomButtonVisible);
    const showFooter = useSelector(isLocalParticipantModerator);
    const showMuteAllButton = useSelector(isMuteAllVisible);
    const showMoreActionsButton = useSelector(isMoreActionsVisible);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [contextOpen, setContextOpen] = useState(false);
    const [searchString, setSearchString] = useState('');
    const onWindowClickListener = useCallback((e) => {
        // @ts-ignore
        if (contextOpen && !findAncestorByClass(e.target, classes.footerMoreContainer)) {
            setContextOpen(false);
        }
    }, [contextOpen]);
    useEffect(() => {
        window.addEventListener('click', onWindowClickListener);
        return () => {
            window.removeEventListener('click', onWindowClickListener);
        };
    }, []);
    useEffect(() => {
        const heading = document.getElementById('participants_pane-heading');
        if (heading) {
            heading.focus();
        }
    }, [paneOpen]);
    useEffect(() => {
        if (maxConcurrentParticipants >= conCurrentParticipant && maxParticipants >= historyParticipantLength) {
            return;
        }
        if (maxConcurrentParticipants < conCurrentParticipant) {
            maxConcurrentParticipants = conCurrentParticipant;
        }
        if (maxParticipants < historyParticipantLength) {
            maxParticipants = historyParticipantLength;
        }
        const params = {
            maxNumberOfConcurrentUser: maxConcurrentParticipants,
            maxNumberOfParticipant: maxParticipants
        };
        const roomId = location.pathname;
        const fetchParticipants = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield fetch(`/livi/api/preuser/videoconference${roomId}`, {
                    method: "PUT",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(params)
                }).then(res => {
                    console.log(res);
                    if (res.status == 200) {
                        res.json().then(data => {
                            console.log(data);
                        });
                    }
                });
            }
            catch (error) {
                console.log(error);
            }
        });
        fetchParticipants();
    }, [participantsCount]);
    const onClosePane = useCallback(() => {
        // 더보기 메뉴에 버튼이 들어깄을 때 예외처리
        const toolbar = document.getElementById('toolbar-participants');
        if (toolbar) {
            console.log(toolbar.firstChild);
            // @ts-ignore
            toolbar.firstChild.focus();
        }
        dispatch(close());
    }, []);
    const onDrawerClose = useCallback(() => {
        setContextOpen(false);
    }, []);
    const onMuteAll = useCallback(() => {
        dispatch(openDialog(MuteEveryoneDialog));
    }, []);
    const onToggleContext = useCallback(() => {
        setContextOpen(open => !open);
    }, []);
    if (!paneOpen) {
        return null;
    }
    return (React.createElement("div", { className: 'participants_pane' },
        React.createElement("div", { className: 'participants_pane-content' },
            React.createElement("div", { className: classes.header },
                React.createElement("h2", { id: 'participants_pane-heading', style: {
                        color: '#fff'
                    }, tabIndex: 0 },
                    t('participantsPane.headings.participantsList'),
                    ` (${participantsCount})`),
                React.createElement(ClickableIcon, { accessibilityLabel: t('participantsPane.close', 'Close'), icon: IconClose, onClick: onClosePane })),
            React.createElement("div", { className: classes.container },
                React.createElement(LobbyParticipants, null),
                React.createElement("br", { className: classes.antiCollapse }),
                React.createElement(MeetingParticipants, { participantsCount: participantsCount, searchString: searchString, setSearchString: setSearchString }),
                isBreakoutRoomsSupported &&
                    React.createElement(RoomList, { searchString: searchString }),
                showAddRoomButton),
            showFooter && (
            // @ts-ignore
            React.createElement("div", { className: classes.footer },
                showMuteAllButton && (React.createElement(Button, { accessibilityLabel: t('participantsPane.actions.muteAll'), labelKey: 'participantsPane.actions.muteAll', onClick: onMuteAll, type: BUTTON_TYPES.SECONDARY })),
                showMoreActionsButton && (
                // @ts-ignore
                React.createElement("div", { className: classes.footerMoreContainer },
                    React.createElement(Button, { accessibilityLabel: t('participantsPane.actions.moreModerationActions'), icon: IconDotsHorizontal, id: 'participants-pane-context-menu', onClick: onToggleContext, type: BUTTON_TYPES.SECONDARY }),
                    React.createElement(FooterContextMenu, { isOpen: contextOpen, onDrawerClose: onDrawerClose, onMouseLeave: onToggleContext }))))))));
});
function _mapStateToProps(state) {
    let sortedParticipantIds = getSortedParticipantIds(state);
    const historyParticipantLength = getHistoryParticipant(state);
    const conCurrentParticipant = getMaxConCurrentParticipant(state); //max Concurrent participants
    sortedParticipantIds = sortedParticipantIds.filter((id) => {
        const participant = getParticipantById(state, id);
        return !isScreenShareParticipant(participant);
    });
    const participantsCount = sortedParticipantIds.length; //current participants
    return {
        participantsCount,
        sortedParticipantIds,
        historyParticipantLength,
        conCurrentParticipant
    };
}
export default connect(_mapStateToProps)(ParticipantsPane);
